import { CommonConstants } from '@/constants/common';

export default {
  mounted(el, binding, vnode) {
    el.addEventListener(
      'blur',
      (e) => {
        let trimmedValue = e.target.value.trim();
        e.target.value = trimmedValue.replace(CommonConstants.EMOJI_REGEX, '');
        el.value = trimmedValue.replace(CommonConstants.EMOJI_REGEX, '');

        let event;
        if (typeof Event === 'function') {
          event = new Event('input', { bubbles: true });
        } else {
          event = document.createEvent('Event');
          event.initEvent('input', true, true);
        }
        vnode.el.dispatchEvent(event);
      },
      true
    );
  },
};
